import { render, staticRenderFns } from "./recond.vue?vue&type=template&id=5dcaa00a&scoped=true&"
import script from "./recond.vue?vue&type=script&lang=js&"
export * from "./recond.vue?vue&type=script&lang=js&"
import style0 from "./recond.vue?vue&type=style&index=0&id=5dcaa00a&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcaa00a",
  null
  
)

export default component.exports